module.exports = __webpack_public_path__ + "media/application/images/img/overlays/07-f8da0281186df8f17f732a2a22aa0efa.png";